import { ALL_FILTER_OPTION } from 'shared/constants'
import { getQueryValue as genericFunc } from 'shared/utils/api'

export const getQueryValue = genericFunc(ALL_FILTER_OPTION)
